import { render, staticRenderFns } from "./expert-manage.vue?vue&type=template&id=1796f89a&scoped=true&"
import script from "./expert-manage.vue?vue&type=script&lang=js&"
export * from "./expert-manage.vue?vue&type=script&lang=js&"
import style0 from "./expert-manage.vue?vue&type=style&index=0&id=1796f89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796f89a",
  null
  
)

export default component.exports